export default __webpack_public_path__ + "static/media/6.19c1f88b.jpg";